/**
 * Debounce is used to postpone the decorated method execution until after wait milliseconds have elapsed since the last time it was invoked.
 * @param duration Duration of waiting time in milliseconds
 */
export const Debounce = (duration: number, keyFn?: (...args) => string) => {
  return (_target: any, key: string, descriptor: PropertyDescriptor): void => {
    const originalMethod = descriptor.value;

    if (keyFn && keyFn.length > originalMethod.length) {
      console.error(`Debounce decorator keyFn argument list must match the decorated function (${key}). `);
    }

    descriptor.value = function (...args) {
      this.__debounce = this.__debounce || {};
      const debounceKey = keyFn ? `${key}.${keyFn(...args)}` : key;
      clearTimeout(this.__debounce[debounceKey]);
      this.__debounce[debounceKey] = setTimeout(() => {
        originalMethod.call(this, ...args);
      }, duration);
    };
  };
};
